import { Query } from '@tanstack/react-query';
import { queryKeys } from 'shared/api/queryKeys';
import { getRoutesByIntegration } from './routesApi';

type ProviderRoutes = Awaited<ReturnType<typeof getRoutesByIntegration>>;

// The Routes a provider integration feeds, one cache entry per provider for
// every page that asks (the Route page counts its provider's other Routes, the
// Connection page lists the Routes it provides). Reused for a minute, so moving
// from a Route to its Connection doesn't ask again; a failed lookup is never
// reused, and saves mark it out of date (see cacheRefresh).
export const providerRoutesQuery = (token: string, providerId: string) => ({
  queryKey: queryKeys.routes.byProvider(providerId),
  queryFn: () => getRoutesByIntegration(token, 'provider', providerId),
  staleTime: (query: Query<ProviderRoutes>) =>
    query.state.data?.ok ? 60 * 1000 : 0,
});
